(function () {
  function countPaidItems(items) {
    return (items || []).reduce(function (sum, item) {
      return item.final_line_price > 0 ? sum + item.quantity : sum;
    }, 0);
  }

  window.OlimpFreeShipping = { countPaidItems: countPaidItems };

  class FreeShippingQuantity extends HTMLElement {
    connectedCallback() {
      this.minimum = Number(this.dataset.minimum) || 0;
      this.render(Number(this.dataset.paidCount) || 0);
      this.onCartUpdated = (event) => {
        const cart = event.detail && event.detail.cart;
        if (cart && cart.items) this.render(countPaidItems(cart.items));
      };
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
    }

    render(count) {
      const remaining = Math.max(this.minimum - count, 0);
      const done = remaining === 0;
      this.classList.toggle('hidden', count === 0);
      this.classList.toggle('free-shipping-goal--done', done);
      const label = this.querySelector('[data-remaining-label]');
      const text = this.querySelector('[data-labels] [data-n="' + remaining + '"]');
      if (label && text && !done) label.textContent = text.textContent;
      const bar = this.querySelector('progress-bar');
      if (bar) bar.style.setProperty('--percent', Math.min((count * 100) / this.minimum, 100) + '%');
    }
  }

  if (!customElements.get('free-shipping-quantity')) customElements.define('free-shipping-quantity', FreeShippingQuantity);
})();
